import { isMobile } from '../../../src/js/utils/is-mobile';

function PremiumSlider() {
  if ($('.elsa-ai__slider').length) {
    $('.elsa-ai__slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $('.elsa-ai__nav li').on('click', function () {
      const slideIndex = $(this).data('slide');
      $('.elsa-ai__nav li').removeClass('active');
      $('.elsa-ai__slider').slick('slickGoTo', slideIndex);
      $(this).addClass('active');
    });

    $('.elsa-ai__slider').on('afterChange', function (event, slick, currentSlide) {
      $('.elsa-ai__nav li').removeClass('active');
      const targetItem = $('.elsa-ai__nav li').eq(currentSlide);
      targetItem.addClass('active');
    });
  }

  if ($('.elsa-sa__slider').length) {
    $('.elsa-sa__slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $('.elsa-sa__nav li').on('click', function () {
      const slideIndex = $(this).data('slide');
      $('.elsa-sa__nav li').removeClass('active');
      $('.elsa-sa__slider').slick('slickGoTo', slideIndex);
      $(this).addClass('active');
    });

    $('.elsa-sa__slider').on('afterChange', function (event, slick, currentSlide) {
      $('.elsa-sa__nav li').removeClass('active');
      const targetItem = $('.elsa-sa__nav li').eq(currentSlide);
      const container = $('.elsa-sa__nav');
      targetItem.addClass('active');

      if (isMobile()) {
        const scrollLeft = targetItem[0].offsetLeft;
        container[0].scrollTo({
          top: 0,
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    });
  }
}

export default PremiumSlider;
